var swiper = new Swiper(".collectionCategories", {
  slidesPerView: 1,
  spaceBetween: 10,
  freeMode: true,
  mousewheel: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    0: {
      slidesPerView: 3.4,
      spaceBetween: 0,
    },
    768: {
      slidesPerView: 5,
      spaceBetween: 30,
    },
    1024: {
      slidesPerView: 6.5,
      spaceBetween: 10,
    },
  },
});
